@if (warningLevel() === 'SOFT' || warningLevel() === 'HARD') {
    <div *transloco="let t" class="usage-banner" role="status">
        <div
            class="flex items-center gap-2 rounded-md border p-3"
            [class]="
                warningLevel() === 'HARD'
                    ? 'border-red-300 bg-red-50 text-red-800'
                    : 'border-amber-300 bg-amber-50 text-amber-800'
            "
        >
            <mat-icon class="text-xl">{{
                warningLevel() === 'HARD' ? 'block' : 'warning'
            }}</mat-icon>
            <p class="text-sm">
                {{ t(messageKey(), messageParams()) }}
                @if (billingEnabled && canUpgrade) {
                    <a
                        [routerLink]="['/pricing']"
                        class="font-medium underline"
                    >
                        {{ t('quota.plan.upgrade') }}
                    </a>
                } @else if (billingEnabled) {
                    {{ t('quota.plan.askAdmin') }}
                }
            </p>
        </div>
    </div>
}
